import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import APP_ROUTES from "../../../../routers/routeConstants";

import { FEED_QUERY_KEYS } from "../queryKeys";
import { CreatePostFormData } from "../types/feed.types";
import { createBasicPost } from "../services/postServices";

export const useCreateBasicPostMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation("feed", { keyPrefix: "toast" });

  const createPostMutation = useMutation({
    mutationFn: (data: CreatePostFormData) => createBasicPost(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      navigate(APP_ROUTES.FEED);
      toast.success(t("postCreatedSuccessfully"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },
  });

  return {
    createPost: createPostMutation.mutate,
    isCreating: createPostMutation.isPending,
    error: createPostMutation.error,
  };
};
